import { context, createResponseComposition } from "msw";

export const delayResponse = createResponseComposition(undefined, [
  context.delay("real"),
]);

interface PaginateResponse<T> {
  data: Array<T>;
  totalPages: number;
}

export const paginateTable = <T>(
  table: Array<T>,
  page: number,
  pageSize: number
): PaginateResponse<T> => {
  const totalPages = Math.ceil(table.length / pageSize);
  const data = table.slice((page - 1) * pageSize, page * pageSize);
  return { data: data, totalPages: totalPages };
};
